export default __webpack_public_path__ + "static/O0316-808ac33153b730445a6c10e4681c4814.png";